module.exports = __webpack_public_path__ + "static/media/IMG_0874.98661420.jpg";